// export NODE_OPTIONS=--openssl-legacy-provider
// #ffd7be

// External dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { findTimeZone, getZonedTime } from 'timezone-support';
import { toDate, format as formatTz, utcToZonedTime } from 'date-fns-tz';
import { nl as localeNL } from 'date-fns/locale';

// Redux thunks (slices)
import { getTheme } from '../redux/slices/themeSlice';
import { getTodoistTask } from '../redux/slices/todoistSlice';
import { isNightMode as selectIsNightMode } from '../utils/hassio';
import { NIGHT_MODE_RED } from '../theme/colors';

// Assets
// import usCaFlag from '../assets/images/flags/us_ca.svg';
import usNyFlag from '../assets/images/flags/us_ny.png';
// import usTxFlag from '../assets/images/flags/us_tx.svg';
import inFlag from '../assets/images/flags/in.svg';
import sgFlag from '../assets/images/flags/sg.svg';
// import jpFlag from '../assets/images/flags/jp.svg';
// import sunIcon from './icons/sun.svg';  // You'll need to create this icon
// import TuLogo from './TuLogo';

// Constants
const WONDER_BASE_URL = 'https://wonder.kevinvandertoorn.com';

// ===== Logo Components =====
const AhLogoWrapper = styled.svg`
  width: 1.2em;
  height: 1.2em;
  position: relative;
  top: 0.3em;
  margin-right: 0em;
  path {
    transition: fill 4s ease-in-out;
  }
`;

function AhLogo({ color }) {
  return (
    <AhLogoWrapper viewBox='0 0 1000 1048'>
      <defs id="defs3860" />
      <g transform="translate(-23.868215,305.62409)" id="layer1">
        <g transform="matrix(15.504137,0,0,15.504137,-5866.0511,-7379.7381)" id="g3928">
          <path d="m 440.45789,488.69519 c 0,0 -14.08691,-26.23902 -14.08691,-26.23902 -1.48437,-2.75878 -4.88404,-3.76831 -7.59765,-2.25586 0,0 -25.78247,14.375 -25.78247,14.375 -1.16089,0.66406 -2.24365,1.82374 -2.73682,3.4668 0,0 -6.91895,24.02954 -6.91895,24.02954 -0.82886,2.87354 0.79224,5.88746 3.62183,6.73219 0,0 40.64454,11.56005 40.64454,11.56005 2.82715,0.84228 5.79345,-0.8081 6.62352,-3.6853 0,0 6.72364,-23.56202 6.72364,-23.56202 0.43701,-1.38305 0.19165,-3.0896 -0.49073,-4.42138 z" id="path3307" style={{ fill: color || '#00a0e2', fillOpacity: 1, fillRule: 'nonzero', stroke: 'white', strokeWidth: 3.5 }} />
          <path d="m 408.86244,493.74646 c 0,0 -4.47022,-8.71704 -7.35962,-8.71704 -2.23999,0.002 -2.43409,2.36817 -2.42798,8.07007 0.009,5.70435 0.31617,7.92602 2.42065,7.92602 2.86012,-0.002 7.36695,-7.27905 7.36695,-7.27905 z m 5.74707,-7.27295 c 2.29003,-3.29712 4.36035,-6.56127 8.23242,-6.56127 4.28712,-0.002 6.61012,3.58642 6.62475,6.60643 0,0.0305 -0.0183,19.3335 -0.0183,19.3335 0,0 -4.81446,0 -4.81446,0 0,0 -0.0208,-18.30078 -0.0208,-18.30078 0,-2.51343 -2.02026,-2.50854 -2.04834,-2.50854 -1.62841,0 -4.62159,4.08325 -7.95289,8.61694 0,0 0,12.19971 0,12.19971 0,0 -4.86816,0.005 -4.86816,0.005 0,0 -0.006,-5.64696 -0.006,-5.64696 0,0 -3.21899,5.64696 -8.03832,5.65307 -5.46754,10e-4 -7.323,-3.75855 -7.33643,-12.7649 -0.009,-8.58032 1.20849,-13.17139 7.06909,-13.17626 4.45801,-0.004 8.28735,6.4917 8.28735,6.4917 0,0 10e-4,-4.11378 10e-4,-4.11378 0,0 4.89135,-6.58813 4.89135,-6.58813 0,0 -0.0208,10.78003 -0.002,10.7544 z" id="path3309" style={{ fill: '#ffffff', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }} />
        </g>
      </g>
    </AhLogoWrapper>
  );
}

const TodoistLogoWrapper = styled.svg`
  width: auto;
  height: 3.8vw;
  position: relative;
  margin-right: 1.8vw;
  top: 0.2vw;
`;

function TodoistLogo({ color }) {
  // #DE483A
  const border = 3;
  return (
    <TodoistLogoWrapper xmlns="http://www.w3.org/2000/svg" viewBox={`${-border} -${border} ${32 + 2 * border} ${32 + 2 * border}`} fill="none" preserveAspectRatio="xMinYMid slice">
      <rect width={32 + 2 * border} x={-border} y={-border} height={32 + 2 * border} fill="black" rx={5.12 + border} />
      <rect width={32} height={32} fill={'#DE483A'} rx="5.12" />

      <path fill="white" d="m6.764 14.993 6.374-3.668.008-.005 6.568-3.78c.277-.16.29-.65-.02-.828l-.217-.124c-.317-.18-.727-.414-.902-.516a1.02 1.02 0 0 0-.997.012c-.155.09-10.501 6.038-10.847 6.235a1.349 1.349 0 0 1-1.339 0L-.072 9.144v2.699l.056.032c1.364.795 4.592 2.675 5.382 3.12.479.27.937.264 1.398-.002Z" />
      <path fill="white" d="m6.764 20.385 6.366-3.664.024-.014 6.56-3.775c.277-.16.29-.651-.02-.828l-.217-.124c-.316-.18-.727-.414-.902-.516a1.02 1.02 0 0 0-.997.012c-.155.089-10.501 6.038-10.847 6.234a1.349 1.349 0 0 1-1.339 0c-.326-.188-5.464-3.174-5.464-3.174v2.698l.056.033c1.365.795 4.592 2.674 5.382 3.12.479.27.937.264 1.398-.002Z" />
      <path fill="white" d="m13.139 22.108-6.375 3.669c-.461.266-.92.272-1.398.002-.79-.446-4.017-2.325-5.382-3.12l-.056-.033v-2.698l5.464 3.174c.413.239.925.236 1.339 0 .346-.196 10.692-6.145 10.847-6.235a1.02 1.02 0 0 1 .997-.012 125.007 125.007 0 0 0 1.12.64c.31.178.296.669.019.829l-6.575 3.784Z" />
    </TodoistLogoWrapper>
  );
}

// ===== Styled Components =====
// Layout components
const DashboardContainer = styled.div`
  height: 100%;
  width: 100%;
  &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${props => WONDER_BASE_URL + props.background});
    background-size: cover;
    opacity: ${props => (props.isLoading || props.hideBackground) ? 0 : 1};
    transition: opacity 3s ease-in-out;
    z-index: -1;
  }
  display: flex;
  flex-direction: column; 
  justify-content: center;
  align-items: center;
  text-align: center;
  ${({ isAprilFool }) => isAprilFool && `
      transform: rotate(180deg);
      transform-origin: center;
  `}
`;

const BackgroundOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  &:before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${props => WONDER_BASE_URL + props.foreground});
    background-size: cover;
    opacity: ${props => (props.isLoading || props.hideBackground) ? 0 : 1};
    transition: opacity 3s ease-in-out;
  }
  z-index: 999;
  pointer-events: none;
  ${({ theme }) => theme?.name?.includes('Pjotr') && `
    animation: moveUpDown 40s ease-in-out infinite normal;
  `}

  @keyframes moveUpDown {
    0% {
      transform: translateY(0);
    }
    5% {
      transform: translateY(-2.5vh);
    }
    10% {
      transform: translateY(0);
    }
    15% {
      transform: translateY(-2.5vh);
    }
    20% {
      transform: translateY(0);
    }
    25% {
      transform: translateY(-2.5vh);
    }
    30%{
      transform: translateY(0);
    }
    35% {
      transform: translateY(-2.5vh);
    }
    40% {
      transform: translateY(0);
    }
    45% {
      transform: translateY(-2.5vh);
    }
    50% {
      transform: translateY(0);
    }
    55% {
      transform: translateY(-2.5vh);
    }
    60%{
      transform: translateY(0);
    }
    65% {
      transform: translateY(-2.5vh);
    }
    70% {
      transform: translateY(0);
    }
    75% {
      transform: translateY(-200vh);
    }
    90% {
      transform: translateY(-70vh);
    }
    100% {
      transform: translateY(0vh);
    }
  }
`;

const ContentContainer = styled.div``;

// Timezone components
const TimezoneContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  opacity: ${({ isNightMode }) => (isNightMode ? 0 : 1)};
  transition: opacity 3s ease-in-out;
  pointer-events: ${({ isNightMode }) => (isNightMode ? 'none' : 'auto')};
`;

const TimezoneDisplay = styled.div`
  font-size: ${({ theme }) => getThemeBasedFontSize(theme, {
  danseMacabre: '6vw',
  efteling: '5vw',
  default: '5vw'
})};
  font-family: ${({ theme }) => getThemeBasedFontFamily(theme)}, sans-serif;
  font-weight: ${({ theme }) => getThemeBasedFontWeight(theme)};
  color: white;
  margin: 0 2rem;
  display: flex;
  align-items: center;
  text-shadow: 
    3px 3px 0 #18252d,
    -3px -3px 0 #18252d,
    3px -3px 0 #18252d,
    -3px 3px 0 #18252d,
    2px 4px 0 #18252d,
    -2px -4px 0 #18252d,
    4px 2px 0 #18252d,
    -4px -2px 0 #18252d,
    2px -4px 0 #18252d,
    -2px 4px 0 #18252d,
    4px -2px 0 #18252d,
    -4px 2px 0 #18252d;
`;

const TodoistTaskText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70vw;
`;

const CountryFlag = styled.img`
  border-radius: 0.6rem;
  height: 3.6vw;
  margin-right: 1.2rem;
  margin-top: ${({ theme }) => (theme?.name?.includes('Danse Macabre') || theme?.name?.includes('Efteling')) ? '-0.3vw' : '0.25vw'};
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  ${props => props.isGrayscale ? "filter: grayscale(1);" : ""}
`;

// Clock components
const MainClock = styled.a`
  font-size: 34vw;
  font-family: ${({ theme }) => {
    if (theme?.name?.includes('Danse Macabre')) return 'Danse Macabre';
    if (theme?.name?.includes('Efteling')) return 'Efteling';
    return 'Salsa';
  }}, sans-serif;
  font-weight: 400;
  color: ${({ isNightMode }) => (isNightMode ? NIGHT_MODE_RED : 'white')};
  transition: color 3s ease-in-out, transform 5s ease-in-out;
  text-decoration: none;
  line-height: 100%;
  display: inline-block;
  transform: ${({ isNightMode }) => (isNightMode ? 'scale(1.2)' : 'scale(1)')};
  transform-origin: center;
  text-shadow: 
    5px 5px 0 #18252d,
    -5px -5px 0 #18252d,
    5px -5px 0 #18252d,
    -5px 5px 0 #18252d,
    3px 7px 0 #18252d,
    -3px -7px 0 #18252d,
    7px 3px 0 #18252d,
    -7px -3px 0 #18252d,
    3px -7px 0 #18252d,
    -3px 7px 0 #18252d,
    7px -3px 0 #18252d,
    -7px 3px 0 #18252d;
`;

const StatusText = styled.div`
  font-size: ${({ theme }) => getThemeBasedFontSize(theme, {
  danseMacabre: '7vw',
  efteling: '6vw',
  default: '6vw'
})};
  font-family: ${({ theme }) => getThemeBasedFontFamily(theme)}, sans-serif;
  font-weight: ${({ theme }) => getThemeBasedFontWeight(theme)};
  color: white;
  text-decoration: none;
  text-align: center;
  text-shadow: 
    3px 3px 0 #18252d,
    -3px -3px 0 #18252d,
    3px -3px 0 #18252d,
    -3px 3px 0 #18252d,
    2px 4px 0 #18252d,
    -2px -4px 0 #18252d,
    4px 2px 0 #18252d,
    -4px -2px 0 #18252d,
    2px -4px 0 #18252d,
    -2px 4px 0 #18252d,
    4px -2px 0 #18252d,
    -4px 2px 0 #18252d;
  opacity: ${({ isNightMode }) => (isNightMode ? 0 : 1)};
  transition: opacity 3s ease-in-out;
  pointer-events: ${({ isNightMode }) => (isNightMode ? 'none' : 'auto')};
`;

const SuperscriptText = styled.sup`
  font-size: 3.5vw;
  position: relative;
  top: 0.14em;
`;

const ClockSeparator = styled.span`
  position: relative;
  top: -0.07em;
  ${({ shouldBlink }) => shouldBlink && `
    animation: fadeOutIn 2s infinite;
  `}

  @keyframes fadeOutIn {
    0% { opacity: 1; }
    50% { opacity: 0; }
    100% { opacity: 1; }
  }
`;

// ===== Utility Functions =====
const getThemeBasedFontSize = (theme, options) => {
  if (theme.name && theme.name.includes('Danse Macabre')) return options.danseMacabre;
  if (theme.name && theme.name.includes('Efteling')) return options.efteling;
  return options.default;
};

const getThemeBasedFontFamily = (theme) => {
  if (theme.name && theme.name.includes('Danse Macabre')) return 'Danse Macabre';
  if (theme.name && theme.name.includes('Efteling')) return 'Efteling';
  return 'Ubuntu';
};

const getThemeBasedFontWeight = (theme) => {
  return (theme.name && (theme.name.includes('Danse Macabre') || theme.name.includes('Efteling'))) ? 'bold' : '500';
};

// ===== Main Component =====
class WorldClockDashboard extends Component {
  state = {
    isLoading: false,
    nextTheme: null
  };

  componentDidMount() {
    this.props.getTheme();
    this.props.getTodoistTask();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.theme.id !== this.props.theme.id) {
      this.handleThemeChange();
    }
  }

  handleThemeChange = async () => {
    this.setState({ isLoading: true });

    await Promise.all([
      this.preloadImage(WONDER_BASE_URL + this.props.theme.background),
      this.preloadImage(WONDER_BASE_URL + this.props.theme.foreground)
    ]);

    this.setState({ isLoading: false });
  };

  preloadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = resolve;
      img.onerror = reject;
      img.src = src;
    });
  };

  onClick = async () => {
    this.setState({ isLoading: true });

    this.props.getTheme();
    this.props.getTodoistTask();
  };

  isAprilFool = () => {
    const { now } = this.props;
    return now && now.getMonth() === 3 && now.getDate() === 1;
  };

  getTimeString = (now, timezoneStr, forceTwoDigitHour = true) => {
    const timezone = findTimeZone(timezoneStr);
    const time = getZonedTime(now, timezone);
    const hours = ((forceTwoDigitHour ? '0' : '') + time.hours).slice(-2);
    const minutes = ('0' + time.minutes).slice(-2);
    return `${hours}:${minutes}`;
  };

  timeLeft = () => {
    const { ahWorkShift } = this.props;
    if (ahWorkShift.start_time == null) return "NA";

    const amsterdamTimeZone = 'Europe/Amsterdam';
    const targetTime = toDate(ahWorkShift.start_time);
    const zonedTime = utcToZonedTime(targetTime, amsterdamTimeZone);
    const targetTimeEnd = toDate(ahWorkShift.end_time);
    const zonedTimeEnd = utcToZonedTime(targetTimeEnd, amsterdamTimeZone);

    const currentTime = new Date();
    const currentMidnight = new Date(currentTime);
    const targetMidnight = new Date(zonedTime);

    currentMidnight.setHours(0, 0, 0, 0);
    targetMidnight.setHours(0, 0, 0, 0);

    const differenceInMilliseconds = targetMidnight - currentMidnight;
    const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));

    if (differenceInDays >= 7) {
      return `${differenceInDays}d`;
    }

    const formattedTimeStart = formatTz(zonedTime, 'EEEEEE HH:mm', { timeZone: amsterdamTimeZone, locale: localeNL })
      .replace(':00', '')
      .replace(':30', '½');
    const formattedTimeEnd = formatTz(zonedTimeEnd, 'HH:mm', { timeZone: amsterdamTimeZone, locale: localeNL })
      .replace(':00', '')
      .replace(':30', '½');
    return `${formattedTimeStart}–${formattedTimeEnd}`.replace('07–13½', '常');
  };

  update = () => {
    const { now } = this.props;
    if (!now) return { timeStrings: {}, dateText: null };

    const timeStrings = {
      // 'us-ca': this.getTimeString(now, 'America/Los_Angeles'),
      // 'us-ny': this.getTimeString(now, 'America/New_York'),

      nl: this.getTimeString(now, 'Europe/Amsterdam', false),
      in: this.getTimeString(now, 'Asia/Kolkata'),
      sg: this.getTimeString(now, 'Asia/Singapore'),
      // jp: this.getTimeString(now, 'Asia/Tokyo'),
    };

    const fullDateOptions = {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    };
    const fullDateText = now.toLocaleDateString('nl', fullDateOptions).replace('.', '');

    const compactDateOptions = {
      weekday: 'short',
      day: 'numeric'
    };
    const compactDateText = now.toLocaleDateString('nl', compactDateOptions).replace('.', '');

    const { temperature, feelsLike, ahWorkShift } = this.props;
    const hasFeelsLike = temperature && feelsLike && Math.abs(Math.round(temperature) - Math.round(feelsLike)) >= 3;
    const hasLongTimeLeft = ahWorkShift && ahWorkShift.start_time && this.timeLeft().length > 6;

    const dateText = (hasFeelsLike || hasLongTimeLeft) ? compactDateText : fullDateText;

    return { timeStrings, dateText };
  };

  getFooterText = (temperature, dateText, theme) => {
    const { feelsLike } = this.props;
    const showFeelsLike = temperature && feelsLike && Math.abs(Math.round(temperature) - Math.round(feelsLike)) >= 3;
    const temperatureText = temperature ? (
      <>
        {temperature}°
        {showFeelsLike && ` (${feelsLike}°)`}
        ・
      </>
    ) : '';
    return (
      <StatusText theme={theme} isNightMode={this.props.isNightMode}>
        {temperatureText}{dateText}・<AhLogo color={theme.color} /> {this.timeLeft()}
      </StatusText>
    );
  };

  renderTimezones = (timeStrings, theme) => {
    const { todoist, weather, now } = this.props;

    if (todoist && todoist.available) {
      const time = todoist.task.due_time ? `${todoist.task.due_time} ` : '';
      return (
        <TimezoneContainer isNightMode={this.props.isNightMode}>
          <TimezoneDisplay theme={theme}>
            <TodoistLogo color={theme.color} />
            <TodoistTaskText>{time}{todoist.task.content}</TodoistTaskText>
          </TimezoneDisplay>
        </TimezoneContainer>
      );
    }

    const convertTo24h = (timeStr) => {
      if (!timeStr) return null;
      const [time, meridiem] = timeStr.split(' ');
      const [hours, minutes] = time.split(':');
      let hour = parseInt(hours);

      if (meridiem === 'PM' && hour !== 12) hour += 12;
      if (meridiem === 'AM' && hour === 12) hour = 0;

      return `${hour.toString().padStart(2, '0')}:${minutes}`;
    };

    const getCurrentMinutes = () => {
      const now = new Date();
      return now.getHours() * 60 + now.getMinutes();
    };

    const getTimeInMinutes = (timeStr) => {
      const [hours, minutes] = timeStr.split(':');
      return parseInt(hours) * 60 + parseInt(minutes);
    };

    const sunrise = convertTo24h(weather?.astronomy?.sunrise);
    const sunset = convertTo24h(weather?.astronomy?.sunset);
    const currentMinutes = getCurrentMinutes();
    const sunriseMinutes = sunrise ? getTimeInMinutes(sunrise) : 0;
    const sunsetMinutes = sunset ? getTimeInMinutes(sunset) : 0;
    const BUFFER_MINUTES = 30;

    let eventTime, eventType, isUpcoming;
    if (currentMinutes < sunriseMinutes) {
      // Before sunrise
      eventTime = sunriseMinutes;
      eventType = '↑';
      isUpcoming = true;
    } else if (currentMinutes < sunriseMinutes + BUFFER_MINUTES) {
      // During sunrise buffer
      eventTime = sunriseMinutes;
      eventType = '↑';
      isUpcoming = false;
    } else if (currentMinutes < sunsetMinutes) {
      // Before sunset
      eventTime = sunsetMinutes;
      eventType = '↓';
      isUpcoming = true;
    } else if (currentMinutes < sunsetMinutes + BUFFER_MINUTES) {
      // During sunset buffer
      eventTime = sunsetMinutes;
      eventType = '↓';
      isUpcoming = false;
    } else {
      // After sunset, show time until next sunrise
      eventTime = sunriseMinutes + 24 * 60;
      eventType = '↑';
      isUpcoming = true;
    }

    const timeDiff = eventTime - currentMinutes;
    const sunEvent = timeDiff <= 60
      ? `${eventType} ${timeDiff} min`
      : `${eventType} ${eventType === '↑' ? sunrise : sunset}`;

    return (
      <TimezoneContainer isNightMode={this.props.isNightMode}>
        <TimezoneDisplay theme={theme}>
          <CountryFlag src={inFlag} isGrayscale={theme.id === 14} theme={theme} />
          {timeStrings.in}
        </TimezoneDisplay>
        <TimezoneDisplay theme={theme}>
          <CountryFlag src={sgFlag} isGrayscale={theme.id === 14} theme={theme} />
          {timeStrings.sg}
        </TimezoneDisplay>
        <TimezoneDisplay theme={theme}>
          {sunEvent}
        </TimezoneDisplay>
      </TimezoneContainer>
    );
  };

  isInWorkShift = () => {
    // Return false if work shift times are not available
    if (!this.props.ahWorkShift.start_time || !this.props.ahWorkShift.end_time) {
      return false;
    }

    // Define the Amsterdam timezone
    const amsterdamTimeZone = 'Europe/Amsterdam';

    // Use the time from Redux state
    const currentTime = this.props.now;

    // Convert work shift times to Amsterdam timezone
    const startTime = utcToZonedTime(toDate(this.props.ahWorkShift.start_time), amsterdamTimeZone);
    const endTime = utcToZonedTime(toDate(this.props.ahWorkShift.end_time), amsterdamTimeZone);

    // Return true if current time is between start and end time
    return currentTime >= startTime && currentTime <= endTime;
  };

  render() {
    const { timeStrings, dateText } = this.update();
    const { temperature, now, theme } = this.props;
    const isAprilFool = this.isAprilFool();
    const shouldBlinkSeparator = now && now.getSeconds() >= 56;
    const [hours, minutes] = timeStrings.nl ? timeStrings.nl.split(':') : ['--', '--'];
    const isInWorkShift = this.isInWorkShift();
    const shouldHideBackground = isInWorkShift || this.props.isNightMode;

    return (
      <DashboardContainer
        background={theme.background}
        isAprilFool={isAprilFool}
        onClick={this.onClick}
        isLoading={theme.isTransitioning}
        hideBackground={shouldHideBackground}
      >
        <ContentContainer>
          {this.renderTimezones(timeStrings, theme)}
          <MainClock isNightMode={this.props.isNightMode}>
            {hours}
            <ClockSeparator shouldBlink={shouldBlinkSeparator}>:</ClockSeparator>
            {minutes}
          </MainClock>
          {this.getFooterText(temperature, dateText, theme)}
        </ContentContainer>
        <BackgroundOverlay
          foreground={theme.foreground}
          theme={theme}
          isLoading={theme.isTransitioning}
          hideBackground={shouldHideBackground}
        />
      </DashboardContainer>
    );
  }
}

// ===== Redux Connection =====
const mapStateToProps = state => ({
  now: state.time.now,
  temperature: state.weather.temperature,
  feelsLike: state.weather.feelsLike,
  emoji: state.weather.emoji,
  ahWorkShift: state.ahwork,
  theme: state.theme,
  todoist: state.todoist,
  weather: state.weather,
  isNightMode: selectIsNightMode(state),
});

const mapDispatchToProps = {
  getTheme,
  getTodoistTask,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorldClockDashboard);